import gql from 'graphql-tag';

import { Query, QueryRegistry } from 'core/index';

const SPACES = gql`
  query CanCreateInSpaces {
    canCreateInSpaces(
      type: "Space"
      obj: "{\\"class_name\\": \\"Space\\",\\"space_type\\":{\\"name\\":\\"PROJECT\\"}}"
    ) {
      id
      spaceType
      hasProSubscription
      hasBillingPermissions
      trialPeriodEnd
      hasValidPaymentMethod
      parent {
        id
        spaceType
      }
      content {
        id
        slug
        avatar {
          id
          path
          url
        }
        imageFallbackChar
        title
      }
    }
  }
`;

// This is no longer used, perhaps we should remove?
export class CanCreateInSpacesQuery extends Query {
  static conf = {
    GQL: SPACES,
    resultPath: 'canCreateInSpaces',
  };
}

export const TEAMS = gql`
  query Teams {
    teams {
      id
      inSpace {
        id
        spaceType
        subscriptionType
      }
      content {
        id
        slug
        canUpdate
        canDelete
        avatar {
          id
          path
          url
        }
        title
      }
      projects {
        totalCount
      }
      sharedFiles {
        totalCount
      }
    }
  }
`;

export class TeamsQuery extends Query {
  static conf = {
    GQL: TEAMS,
    resultPath: 'teams',
  };
}

const FILTER_FIELDS = gql`
  fragment FilterFields on Space {
    id
    spaceType
    content {
      id
      slug
      avatar {
        id
        path
        url
      }
      title
      imageFallbackChar
    }
  }
`;

const AUTOCOMPLETE_SPACES = gql`
  ${FILTER_FIELDS}
  query SpacesComplete($complete: String) {
    spacesComplete(complete: $complete) {
      ...FilterFields
    }
  }
`;

export class CompleteSpacesQuery extends Query {
  static conf = {
    GQL: AUTOCOMPLETE_SPACES,
    varNames: ['complete'],
    resultPath: 'spacesComplete',
  };
}

QueryRegistry.add('spaces.CompleteSpacesQuery', CompleteSpacesQuery);

const SPACES_BY_ID = gql`
  ${FILTER_FIELDS}
  query Spaces($ids: [ID]) {
    spaces(ids: $ids) {
      ...FilterFields
    }
  }
`;

export class SpacesQuery extends Query {
  static conf = {
    GQL: SPACES_BY_ID,
    varNames: ['ids'],
    resultPath: 'spaces',
  };
}

export const INITIATIVE_PLAN_VALIDATION = gql`
  query InitiativePlanValidation($slug: String!, $obj: JSONString) {
    initiative(slug: $slug) {
      id
      hasProSubscription
      trialPeriodEnd
      billingSubscriptions {
        id
        cancelAtPeriodEnd
        plan {
          name
        }
      }
      inSpace {
        id
      }
      canCreateIn(obj: $obj)
      canDeleteIn(obj: $obj)
      avatar {
        url
      }
      flags
      creditCards {
        id
      }
      content {
        title
        slug
      }
    }
  }
`;

export const PROFILE_SPACE = gql`
  query ProfileSpace($username: String!) {
    profile(username: $username) {
      id
      inSpace {
        id
        spaceType
        subscriptionType
      }
      content {
        id
        slug
      }
      projects {
        totalCount
      }
      sharedFiles {
        totalCount
      }
      sharedWithFiles {
        totalCount
      }
      sharedWithProjects {
        totalCount
      }
    }
  }
`;

export const INITIATIVE_SPACE = gql`
  query InitiativeSpace($slug: String!) {
    initiative(slug: $slug) {
      id
      inSpace {
        id
        spaceType
        subscriptionType
      }
      content {
        id
        slug
        canUpdate
        canDelete
        avatar {
          id
          path
          url
        }
        title
      }
      projects {
        totalCount
      }
      sharedFiles {
        totalCount
      }
    }
  }
`;

export const PROFILE_PLAN_VALIDATION = gql`
  query ProfilePlanValidation($username: String!, $obj: JSONString) {
    profile(username: $username) {
      id
      billingSubscriptions {
        id
        cancelAtPeriodEnd
      }
      billingSubscriptions {
        id
        cancelAtPeriodEnd
      }
      creditCards {
        id
      }
      canCreateIn(obj: $obj)
      canDeleteIn(obj: $obj)
      content {
        title
        slug
      }
      avatar {
        url
      }
    }
  }
`;
